import axios from 'axios';

(function () {
    'use strict';

    window.moment = require('moment');
    window.axios = axios;
    // require('sweetalert');

    require('./portal/helpers/SerializeObject');
    require('./portal/helpers/Extensions').register();

    require('./portal/modules/Forms');

    require('./portal/components/Booking');
    require('./portal/components/bookings/BookingLink');
    // require('./portal/components/Tables');
    // require('./portal/components/RichTextEditor');
    // require('./portal/components/dashboard/WorldMapWidget');

    require('./portal/pages/widgets/form');
    require('./portal/pages/reports/bookings');
    require('./portal/pages/reports/agents');
    require('./portal/pages/reports/feedback');
    require('./portal/pages/reports/feedback-graphs');
    require('./portal/pages/tools/refresh');
    require('./portal/pages/users');
    require('./portal/pages/partner/partner-bookings');
    require('./portal/pages/loyalty/list');
    require('./portal/pages/taxes/taxes');
    require('./portal/pages/billing-and-reconciliation');
    require('./portal/pages/franchise-locations');
    require('./portal/pages/wheels-form-requests');
})();



// WEBPACK FOOTER //
// ./resources/scripts/portal.js